//
//
//
//
//
//
//
//
//
//

/**
 * @figma https://www.figma.com/file/cBHD57QcCt9WDT4e7e2B3w/hse_general_library?node-id=2878%3A36
 * @storybook /?path=/story/layout-space--playground
 * @react /src-components-space
 * @reactStorybook /?path=/story/layout-space--playground
 */
var script = {
  name: 'HseSpace',
  props: {
    /**
     * Размер компонента
     * @values small_3x, small_2x, small_x, small, medium, medium_x, large, large_x, large_2x, large_3x, large_4x
     */
    size: {
      type: String,
      default: 'medium'
    },
    /**
     * Горизонтальный отступ
     */
    horizontal: {
      type: Boolean,
      default: false
    },
    /**
     * Вертикальный отступ
     */
    vertical: {
      type: Boolean,
      default: false
    }
  }
};

export default script;
